import { render, staticRenderFns } from "./OVSearchInput.vue?vue&type=template&id=38ffb88c&scoped=true&lang=pug"
import script from "./OVSearchInput.vue?vue&type=script&lang=js"
export * from "./OVSearchInput.vue?vue&type=script&lang=js"
import style0 from "./OVSearchInput.vue?vue&type=style&index=0&id=38ffb88c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ffb88c",
  null
  
)

export default component.exports